export default {
  sidebarState: state => state.sidebar,
  links: state => state.links
}
